export default {
  MuiSnackbar: {
    root: {
      boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.15)',
      borderRadius: '5px',
      zIndex: 1299,
    },
    anchorOriginTopCenter: {
      left: '20px',
      right: '20px',
      top: '56px',
    },
  },
};
